/* eslint-disable @typescript-eslint/no-explicit-any */

// import React from "react";
// import { useEffect, useState } from "react";
// import Swal from "sweetalert2";
// import * as yup from "yup";
// import { useForm, Controller } from "react-hook-form";
// import { useNavigate } from "react-router-dom";
// import { yupResolver } from "@hookform/resolvers/yup";
// import {
//   cleannerError,
//   getInTechTel,
//   getInTechPhone,
//   validatePhone,
//   showModal,
// } from "../../../../../utils/Utils";
// import {
//   OrderFormData,
//   Order,
// } from "../../../../../utils/api/order/order.type";
// import {
//   useAddOrEditOrderMutation,
//   useAddOrEditOrderVisiteurMutation,
//   useAddOrEditOrderNotUserMutation,
//   useDeleteOrderMutation,
// } from "../../../../../utils/api/order/order.api";
// import { Color } from "../../../../../utils/theme";
// import { FaTrash } from "react-icons/fa";
// import { useDelete } from "../../../../../utils/helpers";
// import { useAppSelector, useAppDispatch } from "../../../../../redux/hook";
// import {
//   buildCatalogPath,
//   CATALOG_ACQUISITION_CHANNEL,
//   isCatalogOrderContext,
//   isCatalogPath,
// } from "../../../../../catalog/catalogTenant";
// import {
//   ApiBaseUrl,
//   IntechApikey,
//   AppBaseUrl,
//   Env,
// } from "../../../../../utils/http";
// import { removeCart } from "../../../../../redux/slice/useCartSlice";
// import { useCheckStatusPaiement } from "../../../../../utils/Intech";
// import { GoogleAdresseType } from "../../../../../utils/type";

// function UseAddOrUpdateOrderForm(
//   next: any,
//   previous: any,
//   skipPaymentStep: boolean, // ← ajouter ce paramètre
//   panier?: any,
//   total?: number,
//   order?: Order
// ) {

//   // ─── Validation conditionnelle ────────────────────────────────────
//   const validationSchema = yup.object().shape({
//     step: yup.number().default(1),
//     // ... autres champs ...

//     mode_de_paiement: yup.string().when("step", {
//       is: 2,
//       then: () =>
//         skipPaymentStep  // si on saute le paiement → pas obligatoire
//           ? yup.string().nullable()
//           : yup.string().required().label("Le mode de paiement"),
//     }),
//   });

//   // ─── onSubmit conditionnel ────────────────────────────────────────
//   const onSubmit = async (data: OrderFormData) => {
//     // ...
//     if (data?.step && data?.step < 2) {
//       if (skipPaymentStep) {
//         // Pas d'étape paiement → forcer CASH et soumettre directement
//         setValue("mode_de_paiement", "CASH");
//         data["mode_de_paiement"] = "CASH";
//         onSubmitValid(data); // ← soumettre sans passer par l'étape 2
//       } else {
//         setValue("step", 2);
//         next(); // → aller à l'étape paiement normalement
//       }
//     } else {
//       // Étape finale → confirmation téléphone + submit
//       Swal.fire({ /* ... */ });
//     }
//   };
// }
// export function DeleteOrder({ item }: { item: Order }) {
//   console.log("item", item);
//   const [deleteItem, { isSuccess, isError, error }] = useDeleteOrderMutation();
//   const onDelete = useDelete<Order>({
//     item,
//     deleteItem,
//     isSuccess,
//     isError,
//     error,
//     question: "cette commande",
//     successMessage: "Commande supprimé",
//   });
//   return (
//     <button
//       className="btn with-tooltip btn-action-icon-delete"
//       data-tooltip-content="Supprimer"
//       style={{ color: "#E53E3E" }}
//       onClick={onDelete}
//     >
//       <FaTrash />
//     </button>
//   );
// }

// export default UseAddOrUpdateOrderForm;
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  cleannerError,
  getInTechTel,
  validatePhone,
} from "../../../../../utils/Utils";
import {
  OrderFormData,
  Order,
} from "../../../../../utils/api/order/order.type";
import {
  useAddOrEditOrderMutation,
  useAddOrEditOrderNotUserMutation,
  useDeleteOrderMutation,
} from "../../../../../utils/api/order/order.api";
import { Color } from "../../../../../utils/theme";
import { FaTrash } from "react-icons/fa";
import { useDelete } from "../../../../../utils/helpers";
import { useAppSelector, useAppDispatch } from "../../../../../redux/hook";
import {
  buildCatalogPath,
  CATALOG_ACQUISITION_CHANNEL,
  isCatalogOrderContext,
  isCatalogPath,
} from "../../../../../catalog/catalogTenant";
import { ApiBaseUrl, AppBaseUrl, Env } from "../../../../../utils/http";
import { removeCart } from "../../../../../redux/slice/useCartSlice";
import { GoogleAdresseType } from "../../../../../utils/type";

function UseAddOrUpdateOrderForm(
  next: any,
  previous: any,
  skipPaymentStep: boolean, // ← true = pas de modes paiement en ligne configurés
  panier?: any,
  total?: number,
  order?: Order
) {
  const { user } = useAppSelector((s) => s?.user);
  const [code, setCode] = useState<string>("");
  const [phone, setPhone] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [adresse, setAdresse] = useState("");
  const navigate = useNavigate();

  // ─── Schéma de validation ──────────────────────────────────────────────────
  // Si skipPaymentStep=true → mode_de_paiement n'est pas requis (CASH forcé)
  // Si skipPaymentStep=false → mode_de_paiement requis à l'étape 2
  const validationSchema = yup.object().shape({
    step: yup.number().default(1),

    nom_client: yup.string().when("step", {
      is: 1,
      then: () =>
        user
          ? yup.string().nullable().label("Le nom")
          : yup.string().required().label("Le nom"),
    }),

    prenom_client: yup.string().when("step", {
      is: 1,
      then: () =>
        user
          ? yup.string().nullable().label("Le prénom")
          : yup.string().required().label("Le prénom"),
    }),

    email_client: yup.string().when("step", {
      is: 1,
      then: () => yup.string().email().nullable().label("L'email"),
    }),

    telephone: yup.string().when("step", {
      is: 1,
      then: () => validatePhone(yup, code).required(),
    }),

    adresse: yup.string().when("step", {
      is: 1,
      then: () => yup.string().required().label("L'adresse"),
    }),

    mode_de_paiement: yup.string().when("step", {
      is: 2,
      then: () =>
        skipPaymentStep
          ? yup.string().nullable() // pas obligatoire → CASH sera forcé
          : yup.string().required().label("Le mode de paiement"),
    }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    control,
  } = useForm<OrderFormData>({
    resolver: yupResolver(validationSchema),
  });

const [option, setOption] = useState<{ label: string; value: string } | undefined>(undefined);

  const [modalConnexion, setModalConnexion] = useState(false);

  const [addOrUpdateOrder, { isLoading, isSuccess, error, isError }] = user
    ? useAddOrEditOrderMutation()
    : useAddOrEditOrderNotUserMutation();

  const handleChangePhone = (item: any, country: any) => {
    setCode(country?.countryCode);
    setPhone(item);
    if (parseInt(item) !== parseInt(country?.dialCode)) {
      setValue("telephone", "+" + item);
    } else {
      setValue("telephone", "");
    }
  };

  const onChangeAdresse = (val: GoogleAdresseType) => {
    if (val?.rue) {
      setValue("adresse", val?.rue);
      setAdresse(val?.rue);
    } else {
      setValue("adresse", val as any);
      setAdresse(val as any);
    }
  };

  useEffect(() => {
    cleannerError(errors, clearErrors);
  }, [clearErrors, errors]);

  useEffect(() => {
    setPhone(user?.telephone);
  }, [user]);

  const callBictorysCheckout = async (
    public_key: string,
    charges_url: string,
    payload: Record<string, unknown>
  ): Promise<string | null> => {
    try {
      // Appel via notre proxy Django pour éviter le blocage CORS
      const proxyRes = await fetch(`${ApiBaseUrl}/api/bictorys/proxy-checkout/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ public_key, charges_url, payload }),
      });
      const proxyData = await proxyRes.json();
      if (proxyData?.url) return proxyData.url;
      const errMsg =
        proxyData?.error ||
        proxyData?.message ||
        `Erreur Bictorys (${proxyRes.status})`;
      throw new Error(errMsg);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Erreur inconnue Bictorys";
      Swal.fire({
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 6000,
      });
      return null;
    }
  };

  // ─── Soumission finale (API) ───────────────────────────────────────────────
  const onSubmitValid = async (data: OrderFormData) => {
    data["canale_acquisition"] = isCatalogOrderContext()
      ? CATALOG_ACQUISITION_CHANNEL
      : "Site web";

    const res: any = await addOrUpdateOrder({ data });

    if ("data" in res) {
      const resData = (res as any)?.data;

      if (data?.mode_de_paiement == "CASH") {
        dispatch(removeCart());
        Swal.fire({
          icon: "success",
          title: "Merci pour la confiance",
          text: "Votre commande a bien été prise en compte. Veuillez consulter vos mails.",
          iconColor: Color.success,
          showConfirmButton: false,
          timer: 9000,
        }).then(() => {
          navigate(isCatalogPath() ? buildCatalogPath("/") : "/", {
            replace: true,
          });
        });
        return;
      }

      // Plan B (fallback) : proxy Django + clé publique si le backend le demande
      if (resData?.bictorys_checkout) {
        const redirectUrl = await callBictorysCheckout(
          resData.public_key,
          resData.charges_url,
          resData.payload
        );
        if (redirectUrl) {
          dispatch(removeCart());
          window.location.href = redirectUrl;
        }
        return;
      }

      // Plan A / Wave / Stripe / Paygate : le backend retourne déjà l'URL de paiement
      const payUrl = resData?.url;
      if (payUrl) {
        dispatch(removeCart());
        window.location.href = payUrl;
      }
    }

    if ("error" in res) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: res?.error?.data?.message
          ? res?.error?.data?.message
          : "Une erreur est survenue",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  };

  // ─── onSubmit principal ────────────────────────────────────────────────────
  const onSubmit = async (data: OrderFormData) => {
    const phone: string = data?.telephone ?? "";

    data["page"] = "paiement";
    data["env"] = AppBaseUrl.replace(/\/$/, "");
    data["canale_acquisition"] = isCatalogOrderContext()
      ? CATALOG_ACQUISITION_CHANNEL
      : "Site web";

    setLoading(true);

    // ── Étape 1 (Livraison) ──────────────────────────────────────────────────
    if (data?.step && data.step < 2) {

      if (skipPaymentStep) {
        // Pas de modes paiement en ligne → forcer CASH et soumettre directement
        // Confirmation du numéro avant soumission
        Swal.fire({
          icon: "question",
          html:
            `Est ce que ce numéro de téléphone est bien correct : </br></br><h3><strong>` +
            getInTechTel(phone) +
            `</strong></h3>`,
          title: "Attention !",
          iconColor: Color.themeColor,
          showConfirmButton: true,
          showDenyButton: true,
          denyButtonText: "Non, Modifier le téléphone",
          confirmButtonText: "Oui, Valider ma commande",
          confirmButtonColor: Color.themeColor,
          denyButtonColor: "#aaa",
        }).then((result) => {
          if (result.isConfirmed) {
            // Forcer le mode CASH et soumettre
            data["mode_de_paiement"] = "CASH";
            setValue("mode_de_paiement", "CASH");
            onSubmitValid(data);
          } else if (result.isDenied) {
            setLoading(false);
            // Rester sur l'étape livraison
          }
        });

      } else {
        // Modes de paiement disponibles → aller à l'étape paiement
        setValue("step", 2);
        next();
        setLoading(false);
      }

    // ── Étape 2 (Paiement) ───────────────────────────────────────────────────
    } else {
      Swal.fire({
        icon: "question",
        html:
          `Est ce que ce numéro de téléphone est bien correct : </br></br><h3><strong>` +
          getInTechTel(phone) +
          `</strong></h3>`,
        title: "Attention !",
        iconColor: Color.themeColor,
        showConfirmButton: true,
        showDenyButton: true,
        denyButtonText: "Non, Modifier le téléphone",
        confirmButtonText: "Oui, Valider mon panier",
        confirmButtonColor: Color.themeColor,
        denyButtonColor: "#aaa",
      }).then((result) => {
        if (result.isConfirmed) {
          onSubmitValid(data);
        } else if (result.isDenied) {
          setValue("step", 1);
          previous();
        }
      });
    }
  };

  return {
    register,
    errors,
    onSubmit: handleSubmit(onSubmit),
    setValue,
    isLoading,
    option,
    Controller,
    control,
    handleChangePhone,
    onChangeAdresse,
    adresse,
    phone,
  };
}

export function DeleteOrder({ item }: { item: Order }) {
  const [deleteItem, { isSuccess, isError, error }] = useDeleteOrderMutation();
  const onDelete = useDelete<Order>({
    item,
    deleteItem,
    isSuccess,
    isError,
    error,
    question: "cette commande",
    successMessage: "Commande supprimée",
  });
  return (
    <button
      className="btn with-tooltip btn-action-icon-delete"
      data-tooltip-content="Supprimer"
      style={{ color: "#E53E3E" }}
      onClick={onDelete}
    >
      <FaTrash />
    </button>
  );
}

export default UseAddOrUpdateOrderForm;


